import React from 'react'

import { NODE_STATS_TABLE_ITEM } from 'common/builder/components/chart/FlowChart/constants'
import { FlowChartNodeStat } from 'common/builder/components/chart/FlowChart/types/FlowChartNodeStat'
import { useFlowChartNodeContext } from 'common/builder/hooks/useFlowChartNodeContext'

import * as styles from './NodeStatsItem.styles'

interface NodeStatsItemProps {
  item: FlowChartNodeStat | null
}

export const NodeStatsItem = React.memo(({ item }: NodeStatsItemProps) => {
  const { handlers } = useFlowChartNodeContext()

  const [isHover, setHover] = React.useState(false)

  if (item == null) {
    return <view style={styles.wrapper} />
  }

  const style = isHover ? styles.wrapperHover : styles.wrapper
  const value = isHover ? item.hoverValue || item.value : item.value

  const handleMouseOver = () => setHover(true)
  const handleMouseOut = () => setHover(false)

  const handleClick = () => {
    if (item.segmentId) {
      handlers?.onSelectSegment(item.segmentId)
    }
  }

  return (
    <view
      name={NODE_STATS_TABLE_ITEM}
      style={style}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onClick={handleClick}
    >
      <richtext style={styles.counter} text={value} />
      <richtext style={styles.title} text={item.label} />
    </view>
  )
})
